<div class="container-fluid px-3">
    <app-assign-users [customerDataInput]="customerData"></app-assign-users>
    <app-list-customer-users [customerDataInput]="customerData"></app-list-customer-users>
  </div>